import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Button } from 'antd';
import { differenceInCalendarDays, isAfter } from 'date-fns';
import React from 'react';
import { LoginContext } from '../contexts/LoginContext';

const ExpiryChip = ({ expireDate, testLeft }) => {
    const theme = useTheme();
    const { setPageKey } = React.useContext(LoginContext);
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const now = new Date();
    const expiryUTC = new Date(expireDate);
    console.log("utc date is ", expiryUTC);
    const expiry = new Date(expiryUTC?.getTime() - (expiryUTC?.getTimezoneOffset() * 60 * 1000));
    console.log("current  date is ", expiry);
    const isActive = isAfter(expiry, now);
    const daysLeft = isActive ? differenceInCalendarDays(expiry, now) : 0;

    return (
        <Box sx={{ marginTop: '1rem' }}>
            <Button
                onClick={() => { setPageKey(9) }}
                style={{ fontSize: '13px', fontWeight: 600, backgroundColor: "rgb(255, 164, 34)", color: "white", textTransform: 'none', fontFamily: 'poppins' }}
            >
                Subscription
            </Button>


            {/* Info below the Chip .Hide tests left on mobile*/}
            <Box sx={{ mt: 0.1, pl: 1 }}>
                <Typography variant="caption" color="text.secondary" fontFamily="poppins" sx={{ fontSize: '11px', fontWeight: '600' }}>
                    {isActive ? `Days left - ${daysLeft}` : <span style={{ color: 'red' }}>{"Expired"}</span >}
                </Typography>
                <Typography variant="caption" color="text.secondary" fontFamily="poppins" sx={isMobile ? { display: 'none' } : { fontSize: '11px', fontWeight: '600' }}>
                    {`, Select More - ${testLeft}`}
                </Typography>
            </Box>
        </Box>
    );
};

export default ExpiryChip;
